import { FIND_LEADS_SAVED_SEARCH_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type {
    ServiceFactoryDependency,
    ViewModelFactory,
} from "../../../../modules/leads-search/sub-modules/saved-search/types/types";
import advancedSearchTrackingService from "../../services/tracking/advancedSearchTrackingService";
import type { SaveSearchMode } from "../../types/saved-searches";

import { DEFAULT_SEARCH_NAME } from "./const";

const createSavedSearchesService = ({ trackingService }: ServiceFactoryDependency) => {
    const saveSearchViewModelByMode: Record<SaveSearchMode, ViewModelFactory> = {
        manual: () => ({
            onSuccess(savedSearchId: string) {
                void proNavigator.go(FIND_LEADS_SAVED_SEARCH_ROUTE, { savedSearchId }, { reload: true });
            },
            onSubmitTracked(name: string) {
                trackingService.saveSearch.manual.trackSaveSearchConfirmed(name);
            },
            onCancelTracked() {
                trackingService.saveSearch.manual.trackSaveSearchCanceled();
            },
        }),
        onExport: () => ({
            predefinedSearchName: DEFAULT_SEARCH_NAME,
            onSubmitTracked(name: string, isDefaultName: boolean) {
                trackingService.saveSearch.onExport.trackSaveSearchConfirmed();

                if (!isDefaultName) {
                    trackingService.saveSearch.trackDefaultSearchNameChange("onExport");
                }
            },
            onCancelTracked() {
                trackingService.saveSearch.onExport.trackSaveSearchCanceled();
            },
        }),
    };

    return {
        initSaveSearchViewModel(saveMode: SaveSearchMode): ViewModelFactory {
            return saveSearchViewModelByMode[saveMode];
        },
    };
};

const savedSearchesService = createSavedSearchesService({
    trackingService: advancedSearchTrackingService,
});

export default savedSearchesService;
